import { useState, useEffect, useRef } from "react";
import img from "../../assets/svgs/menu-btn.svg";
import "./buttonDropdown.css";
import { Spinner } from "../spinner/spinner";

export const ButtonDropdown = ({
	buttonGroup,
	isLoading = false,
	disabled = false
}) => {
	const [toggle, setToggle] = useState(false);
	const dropdownRef = useRef(null);

	useEffect(() => {
		// handles closing of the drop down
		const handleClickOutside = (event) => {
			if (
				dropdownRef.current &&
				!dropdownRef.current.contains(event.target)
			) {
				setToggle(false);
			}
		};

		if (toggle) {
			window.addEventListener("click", handleClickOutside);
		}

		return () => {
			window.removeEventListener("click", handleClickOutside);
		};
	}, [toggle]);

	return (
		<div ref={dropdownRef} className="btn_drop_down_container">
			<button
				onClick={() => setToggle(!toggle)}
				className="btn_dropdown"
				disabled={isLoading || disabled}
			>
				{isLoading ? <Spinner /> : <img src={img} alt="" />}
			</button>

			{toggle && (
				<div className="drop_down_menu">
					{buttonGroup?.map((btn, i) => (
						<p
							key={i}
							onClick={btn?.onClick}
							className={btn?.style ? btn?.style : ""}
						>
							{btn?.name}
						</p>
					))}
				</div>
			)}
		</div>
	);
};
